import { accordion } from "./_accordion";
import { drawer } from "./_drawer";
import { tab } from "./_tab";
import { splide } from "./_splide";
import { scrolltop } from "./_scrolltop";
import { headercolor } from "./_headercolor";
import { mail } from "./_mail";


// ページの内容が完全に読み込まれた後のイベント
document.addEventListener('DOMContentLoaded', () => {
  // Common function execution
  [drawer, scrolltop, headercolor, mail].forEach(fn => fn());

  // Main tag ID retrieval
  const PageId = document.querySelector('main')?.getAttribute('id');

  // Page-specific function execution
  const pageFunctions = {
      'top': [splide],
      'recruit': [accordion],
      'education': [accordion],
      'schedule': [accordion],
      'voice': [accordion],
      'achivement': [accordion, tab],
      'paper2021': [accordion, tab],
  };

  (pageFunctions[PageId] || []).forEach(fn => fn());
});